(function () {
	"use strict";

	angular.module("swurveys.common")
		.factory("sliderService", Handler)

	function Handler($timeout, swipeService) {

    var autoswipe;
		var autoswipeTimeout;
		var defaultSliderState = {
			currentValue: 0,
			selectedValue: "one",
			locked: true
		};

		var scaleValues = ["one", "two", "three", "four", "five"];

		var sliderDemoHasBeenSeen = false;

		var slider = {
			options: {
				start: function (event, ui) {
					slider.state.locked = true;
				},
				stop: function (event, ui) {
					slider.state.locked = false;
					if(autoswipe)
					{
						$timeout.cancel(autoswipeTimeout);
						autoswipeTimeout = $timeout(function(){
							return swipeService.swipeRight();
						}, 1000);
						return;
					}
					$timeout(function(){
						//We're not in a digest cycle! so use $timeout
					  slider.doneSliding = true;
					});
					if(pepContainer){
						pepContainer.toggle(true); // TODO remove global var from service
					}
				}
			},
			state: JSON.parse(JSON.stringify(defaultSliderState)),
			update: function () {
				$timeout.cancel(autoswipeTimeout);
				sliderUpdate();
			},
			doneSliding: false,
			animating: false
		};

		function normalizeSliderState() {
			slider.state = JSON.parse(JSON.stringify(defaultSliderState));
		}

		function sliderUpdate() {

			var valueIndex = Math.floor(slider.state.currentValue / 100);

			var chosenValue = scaleValues[valueIndex];

			slider.state.selectedValue = chosenValue;
		}

		function animateSlider(target, increment) {

			if(slider.state.currentValue === target) {

				if(target === 200) {
					slider.animating = false;
					return;
				}

				$timeout(function () {

					animateSlider(200, -8);

				}, 200);

				return;
			}

			$timeout(function () {
				slider.state.currentValue += increment;

				sliderUpdate();

				animateSlider(target, increment);
			}, 11.5);
		}

		function initializeSlider() {
			normalizeSliderState();

	    if(!sliderDemoHasBeenSeen) {

				sliderDemoHasBeenSeen = true;

				$timeout(function () {
					slider.animating = true;
					animateSlider(400, 8);
				}, 2000);

	    } else {

				slider.doneSliding = false;

		    slider.state.currentValue = 200;
		    sliderUpdate();

	    }

		}

		function getSlider() {
			return slider;
		}

		function getState() {
			return slider.state;
		}
		var enableAutoswipe = function() {
			autoswipe = true;
		}

		return {
			getSlider: getSlider,
			getState: getState,
			normalizeSliderState: normalizeSliderState,
			initializeSlider: initializeSlider,
			enableAutoswipe : enableAutoswipe
		};
	}
}());
